export default __webpack_public_path__ + "static/media/img-use-01.ff1b4020.jpg";